import { render } from "./WarehouseDatatableFormPaymentType.vue?vue&type=template&id=1622fc3b"
import script from "./WarehouseDatatableFormPaymentType.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableFormPaymentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__